import React, { useEffect, useState } from "react";
import MyPagination from "../../../components/Common/MyPagination";
import * as bannerApi from "../../../apis/bannerApi";
import { Table, Card, CardBody, CardTitle, Row, Col, Button, Input, InputGroup } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmDelete from "components/Common/ConfirmDelete";
import "flatpickr/dist/themes/material_blue.css"
import BannerTableItem from "components/TableItem/BannerTableItem";
import MetaTags from 'react-meta-tags';


function ListBanner(props) {
  const [dataOrder, setDataOrder] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [restoreId, setRestoreId] = useState(null);
  const selectedShop = useSelector(state => state.SelectedShop);
  const [dataBanner, setDataBanner] = useState({})
  let history = useHistory();
  const showProductCatItem = () => {
    if (dataBanner) {
      if (dataBanner?.total === 0) {
        return <tr></tr>;
      } else {
        return dataBanner?.data && dataBanner?.data.map((v, i) => {
          return (
            <BannerTableItem
              key={i}
              data={v}
              count={i + 1}
              deleteCallback={setDeleteId}
            />
          );
        });
      }
    }
  };

  const onChangePage = page => {
    let url = props.location.pathname + "?page=" + page;
    history.push(url);
  };
  useEffect(() => {
    fetchData();
  }, [])
  const fetchData = page => {
    bannerApi.getListBanner(fetchDataSuccess, fetchDataFail);
  };
  const fetchDataSuccess = res => {
    const { data } = res.data;
    setDataBanner(data)
  };
  const fetchDataFail = res => {
    alert("Không có dữ liệu");
  };

  const onDelete = id => {
    bannerApi.deleteBanner(id, deleteSuccess, deleteFail);
  };
  const deleteSuccess = res => {
    setDeleteId(null);
    alert(res.data.message);
    fetchData();
  };
  const deleteFail = res => {
    alert(res.message);
    setDeleteId(null);
  };

  return (
    <div className="page-content">
    <MetaTags>
        <title>CMS | Banner</title>
    </MetaTags>
      {deleteId ? (
        <ConfirmDelete
          confirmCallback={() => {
            onDelete(deleteId);
          }}
          cancelCallback={() => {
            setDeleteId(null);
          }}
        />
      ) : (
        ""
      )}
      <Card>
        <CardBody>
          <Card color='light'>
            <CardBody>
              <Row className="justify-content-between">
                <Col xs="auto" sm="auto"><CardTitle className="h4">Danh sách Banner</CardTitle></Col>
                <Col xs="auto" sm="auto">
                  <Link to="/banner/create">
                    {" "}
                    <Button color="primary" className="px-3 rounded-pill">
                      <i className="fas fa-plus mr-2"></i> Thêm mới
                    </Button>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="table-responsive">
            <Table className="table mb-3 mytable">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Tiêu đề</th>
                  <th>Nội dung</th>
                  <th>Ảnh/Video</th>
                  <th>Tình trạng</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>{showProductCatItem()}</tbody>
            </Table>
          </div>
          <MyPagination
            startPage={dataBanner.current_page ? dataBanner.current_page : 1}
            totalItemsCount={dataBanner.total ? dataBanner.total : 5}
            itemsCountPerPage={dataBanner.per_page ? dataBanner.per_page : 10}
            callback={onChangePage}
          />
        </CardBody>
      </Card>
    </div>
  );
}
ListBanner.propTypes = {
  location: PropTypes.object,
};

export default withRouter(ListBanner);
